<template>
  <span>
    <crud-layout-search
      ref="crudLayoutSearch"
      :params="params"
      :interface="nmInterface"
      :id="id"
      :row-buttons="true"
      multiselect
      :name="name"
      @selection="onSelectRow"
    >
      <contract-item-cost-center-page-table
        slot="page-table"
        slot-scope="dataPageTable"
        v-bind="dataPageTable"
        @action-button="dataPageTable.actionButton"
        @show-message="dataPageTable.showMessage"
      />
    </crud-layout-search>

    <cost-center-selection-modal
      ref="costCenterModal"
      :params="pageParams"
      :show="showCostCenterModal"
      @update:model-value="(val) => (showCostCenterModal = val)"
    />
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import ContractItemCostCenterPageTable from './ContractItemCostCenterPageTable'
import CostCenterSelectionModal from './CostCenterSelectionModal.vue'

const { page, pageTable, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [page],
  name: 'ContractItemCostCenter',
  components: {
    CrudLayoutSearch,
    page,
    pageTable,
    ContractItemCostCenterPageTable,
    CostCenterSelectionModal
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ContractItemCostCenter extends Vue {
  showCostCenterModal = false
  pageParams = {}
  itemsTableSelected = []

  get nmInterface () {
    return this.interface
  }

  get page () {
    return page
  }

  onSelectRow (_event) {
    this.itemsTableSelected = _event
    this.updateBulkBindButtonState()
  }

  updateBulkBindButtonState () {
    this.$nextTick(() => {
      const button = this.$refs.crudLayoutSearch?.buttons?.find(btn => btn.name === 'btBulkBindCostCenter')
      if (button) {
        button.disabled = !this.itemsTableSelected || this.itemsTableSelected.length === 0
      }
    })
  }

  async mounted () {
    this.$refs.crudLayoutSearch.onButton('btBulkBindCostCenter', this.openBulkBindModal)
    this.updateBulkBindButtonState()
  }

  openBulkBindModal () {
    // Acessa diretamente através da estrutura de refs do crud-layout-search
    const pageTableComponent = this.$refs.crudLayoutSearch.$children.find(
      child => child.$refs && child.$refs.jtDataTable
    )

    if (!pageTableComponent || !pageTableComponent.$refs.jtDataTable) {
      messageBox.warn(this.$gettext('SELECT_ITEMS_TO_BIND'))
      return
    }

    const selected = pageTableComponent.$refs.jtDataTable.selected
    if (!selected || selected.length === 0) {
      messageBox.warn(this.$gettext('SELECT_ITEMS_TO_BIND'))
      return
    }

    // Validações para itens múltiplos
    if (selected.length > 1) {
      const firstRow = selected[0]

      // Verifica clientType
      const hasDifferentClientType = selected.some(row => row.clientType !== firstRow.clientType)
      if (hasDifferentClientType) {
        messageBox.warn(this.$gettext('CANNOT_SELECT_DIFFERENT_CLIENT_TYPE'))
        return
      }

      // Verifica serviceType
      const hasDifferentServiceType = selected.some(row => row.serviceType !== firstRow.serviceType)
      if (hasDifferentServiceType) {
        messageBox.warn(this.$gettext('CANNOT_SELECT_DIFFERENT_SERVICE_TYPE'))
        return
      }

      // Verifica organizationalStructure
      const hasDifferentOrgStructure = selected.some(row => row.organizationalStructure !== firstRow.organizationalStructure)
      if (hasDifferentOrgStructure) {
        messageBox.warn(this.$gettext('CANNOT_SELECT_DIFFERENT_ORGANIZATIONAL_STRUCTURE'))
        return
      }
    }

    this.pageParams = pageTableComponent.$refs.jtDataTable
    this.showCostCenterModal = true
  }
}
export default ContractItemCostCenter
</script>
